import BrandsSubscriptionsOption from 'owa-brands-subscriptions-option/lib/BrandsSubscriptionsOption';
var brandsSubscriptionsSubCategory = {
    key: 'brandsSubscriptions',
    titleStringKey: 'optionSubcategory_subscriptions',
    options: [BrandsSubscriptionsOption],
};
export default brandsSubscriptionsSubCategory;
//# sourceMappingURL=brandsSubscriptionsSubCategory.js.map